<div class="details-page">
  <!-- Loading Spinner -->
  <div *ngIf="showSpinner" class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <!-- Breadcrumb for regular Provider Details -->
  <div class="search-breadcrumb" *ngIf="locationDetails === null">
    <div [class]="locale === 'es-US' ? 'search-breadcrumb-item-1-spanish' : 'search-breadcrumb-item-1'" style="text-decoration: underline; cursor: pointer;" (click)="clearSearch()">
      {{breadcrumb1}}
    </div>
    <div class="search-breadcrumb-item">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
        <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="search-breadcrumb-item" style="text-decoration: underline; cursor: pointer" (click)="returnToSearchResults()">
      {{breadcrumb2}}
    </div> 
  <div class="search-breadcrumb-item">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
        <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="search-breadcrumb-name">
      {{details.providerName.length > 12 ? (details.providerName.substring(0, 12) + '...') : details.providerName}}
    </div> 
  </div>
  <!-- Breadcrumb for LocationDetails Provider -->
  <div class="search-breadcrumb" *ngIf="locationDetails !== null">
    <div [class]="locale === 'es-US' ? 'prov-search-breadcrumb-item-1-spanish' : 'prov-search-breadcrumb-item-1'" style="text-decoration: underline; cursor: pointer;" (click)="backToLocationSearch()">
      {{locationBreadcrumb1}}
    </div>
    <div class="search-breadcrumb-item">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
        <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="search-breadcrumb-item" style="text-decoration: underline; cursor: pointer" (click)="backToLocationSearchResults()">
      {{locationBreadcrumb2}}
    </div> 
    <div class="search-breadcrumb-item">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
        <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="search-breadcrumb-name"  style="text-decoration: underline; cursor: pointer" (click)="backToLocationDetails()">
      {{locationDetails.locationName.length > 5 ? (locationDetails.locationName.substring(0, 5) + '...') : locationDetails.locationName}}
    </div> 
    <div class="search-breadcrumb-item">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
        <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="search-breadcrumb-name">
      {{details.providerName.length > 5 ? (details.providerName.substring(0, 5) + '...') : details.providerName}}
    </div> 
  </div>

  <!-- Content -->
  <div *ngIf="!showSpinner && details" class="details-body">
    <!-- Hero Photo -->
    <div class="hero-photo-container">
      <img 
        [src]="getProviderPhoto()" 
        [alt]="details.providerName + ' photo'" 
        class="hero-photo"
        [style.background]="'url(' + details.photoUrl + ') lightgray 50% / cover no-repeat'">
    </div>

    <!-- White Content Card -->
    <div class="details-card">
      <!-- Provider Name & Specialty -->
      <div class="provider-name">{{details.providerName}}</div>
      <div class="provider-specialty" *ngIf="details.specialties">{{details.specialties}}</div>

      <!-- Schedule Button -->
      <button mat-raised-button 
              color="primary"
              class="schedule-button" 
              (click)="onScheduleButtonClicked()" 
              *ngIf="canSchedule()">
        {{scheduleBtnText}}
      </button>

      <!-- About Me Section -->
      <div *ngIf="details.about" class="section">
        <div class="section-title">{{aboutLabel}}</div>
        <div class="section-content" [innerHTML]="details.about"></div>
      </div>

      <!-- Education Section -->
      <div *ngIf="hasEducation()" class="section">
        <div class="section-title">
          <span>{{educationLabel}}</span>
        </div>
        <div *ngFor="let education of details.providerEducations" class="education-item">
          <div class="education-label">{{education.label}}</div>
          <div class="education-institution">{{education.institution}}</div>
        </div>
      </div>

      <!-- Languages Section -->
      <div *ngIf="details.languages" class="section">
        <div class="section-title">
          <span>{{langLabel}}</span>
        </div>
        <div class="section-content">{{details.languages}}</div>
      </div>

      <!-- Affiliations Section -->
      <div *ngIf="details.affiliations" class="section">
        <div class="section-title">
          <span>{{affiliationsLabel}}</span>
        </div>
        <div class="section-content">{{details.affiliations}}</div>
      </div>
  </div>
  <!-- Locations Section (Outside Card) -->
    <div *ngIf="hasLocations()" class="locations-section">
      <div class="locations-title">
        <span>{{locationsLabel}}</span>
      </div>
      <div class="locations-list">
        <app-provider-search-details-location-card-mobile
          *ngFor="let location of locationList; let i = index"
          [location]="location"
          [canViewDetails]="locationDetailsProvider === null"
          [attr.data-index]="i"
          [queryCityOrZip]="currentCityOrZip">
        </app-provider-search-details-location-card-mobile>
      </div>
    </div>

  <!-- Error State -->
  <div *ngIf="!showSpinner && !details" class="error-state">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <div class="error-message">Unable to load provider details</div>
    <button mat-raised-button class="retry-button" (click)="loadProviderDetails()">Try Again</button>
  </div>
</div>
